export const routingNumberValidation = (routingNum: any) => {
  if (routingNum.length !== 9 || isNaN(routingNum)) {
    return false;
  } else {
    const digits = routingNum.split('').map(Number);
    const sum =
      digits[0] * 3 +
      digits[1] * 7 +
      digits[2] +
      digits[3] * 3 +
      digits[4] * 7 +
      digits[5] +
      digits[6] * 3 +
      digits[7] * 7 +
      digits[8];
    return sum % 10 === 0;
  }
};
